import * as Yup from 'common/yup';
import {TransportTypeName} from 'common/enums';

export const transportTypeNameSchema = Yup.mixed<TransportTypeName>()
   .oneOf(Object.values(TransportTypeName))
   .defined();
